import axios from "axios"

export default async function fetchPastEvent() {
    const { data } = await axios.get(
        `${process.env.NEXT_PUBLIC_API_URL}events/past`
    )
    return data
}
